import { createContext } from 'react';

const colorContext: {
  theme: 'institute' | 'kine';
} = {
  theme: 'kine',
};

const ColorContext = createContext(colorContext);

export default ColorContext;
